module.exports = __webpack_public_path__ + "static/media/pt-aigfutura-bolditalic-webfont.80709160.svg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/fonts/pt-aigfutura-bolditalic-webfont.svg
// module id = 387
// module chunks = 3